import { HttpErrorResponse } from '@angular/common/http';

export function getErrorMessage(error: HttpErrorResponse): string {
  if (error.status === 0) {
    return 'Network error: Please check your internet connection';
  }
  switch (error.status) {
    case 400:
      return 'Bad request: Please check your input values';
    case 401:
      return 'Unauthorized: Please log in again';
    case 403:
      return 'Access denied: You do not have permission';
    case 404:
      return 'Service not found: Please contact administrator';
    case 500:
    default:
      return 'Server error: Please try again later';
  }
}